import React, { useContext, useState } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'

import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'
import TimeModal from '../../comonents/TimeModal';
import PopUpModal from '../../comonents/PopUpModal';
import MerkleTree from '../../comonents/MerkleTree';

import ConfirmModal from '../../comonents/ConfirmModal';

import { EXPRESS_SERVER_URL } from "../../config";
import axios from '../../axios'

import ErrorModal from '../../comonents/ErrorModal';

import Timer from '../../comonents/Timer'

import { Button, Modal, } from 'react-bootstrap';

let monthNames = ["Jan", "Feb", "Mar", "Apr",
    "May", "Jun", "Jul", "Aug",
    "Sep", "Oct", "Nov", "Dec"];

const checkIsNumber = (n) => {
    if(n === null || n === undefined || n === "") return false;
    n = n.toString();
    return n.match(/^-?[0-9]*$/);
}

// for 1 2 3 4
function Game2CalculationComponent(props) {

    const navigate = useNavigate();

    function toHelp() {
        //navigate('/game2help')
        props.setShowHelpModal(true);
    }

    const [hash, setHash] = useState(0);
    const [nonce, setNonce] = useState(0);

    const [data, setData] = useState({});
    const [dateStr, setDateStr] = useState("");

    const { currHash, setUserAnswer, setCurrHash, blockDetail } = props;

    // var data = blockDetail && blockDetail.datas ? blockDetail.datas[currHash - 1] : null;

    React.useEffect(() => {
        if (blockDetail && blockDetail.datas) {
            setData(blockDetail.datas[currHash - 1])
        }
        if (data.dd) {
            var date = new Date(data.dd.substring(0, 19) + "-08:00");
            setDateStr(`${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`)
        }
    }, [blockDetail, data])

    return (
        <>
            <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem' }}>
                {/* <input type='button' className=' calculation_help fw-bold' value={"Help ?"} onClick={e => toHelp()} /> */}
                {/* <div style={{ marginLeft: "auto", marginRight: 0 }} className='NodeDashboard_titletimebox_top'>
                    <Timer />
                </div> */}

                <div className='row'>
                    <div className='col-4 btn_margin_help' style={{ paddingTop: '2%', paddingBottom: '2%', paddingLeft: '10%', paddingRight: '10%' }}>
                        <input type="button" onClick={e => toHelp()} className=' text-center btn_help ' value="HELP?" />
                    </div>
                    <div className="col-4"></div>
                    <div className=' text-center col-4'>
                        <p className='time_border'>
                            <Timer />
                        </p>
                    </div>
                </div>

                <div className='text-center'>
                    <b>
                        <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>
                            Calculation of Hash {data.did}
                        </p>
                    </b>
                </div>
                <div>
                    Detail of block data<br /><br />
                    Block Index: {currHash}<br /><br />
                    <div className="row">
                        <br />
                        <div className="col-md-12 Block_detail">
                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div> <div> {data.cid}</div>
                            </div> <div className="d-flex justify-content-between">
                                <div>Product ID:</div> <div> {data.pid}</div>
                            </div> <div className="d-flex justify-content-between">
                                <div>Product Quantity:</div> <div> {data.pq} </div>
                            </div> <div className="d-flex justify-content-between">
                                <div>Product Name:</div> <div> {data.pn}</div>
                            </div> <div className="d-flex justify-content-between">
                                <div>Delivery Date:</div> <div> {dateStr}</div>
                            </div>
                        </div>
                    </div>
                    <br />
                    {/* Pre Hash: {blockDetail.bid === 1 ? blockDetail.ph : 0}<br /> */}
                    Pre Hash: {blockDetail.ph}<br />
                </div>
                <br />
                <br />
                <div className='CalculationInput_div'>
                    <div>
                        Hash 1 Value<br />
                        <input type="number" className='Calculation_hash_input' value={hash} onChange={e => setHash(e.target.value)}></input>
                    </div>
                    <br />
                    <div>
                        Nonce<br />
                        <input type="number" className='Calculation_hash_input' value={nonce} onChange={e => setNonce(e.target.value)}></input>
                    </div>
                </div>
            </div>
            <div style={{ paddingTop: '2rem' }}>
                <div className='Btns_Back'>
                    <input type="button" className='Btn_Back' value='Submit' onClick={() => {
                        if(!checkIsNumber(hash) || !checkIsNumber(nonce)) {
                            alert("Please enter a number");
                            return;
                        }
                        setUserAnswer(answer => {
                            let newAnswer = answer;
                            newAnswer[`b${currHash}`] = { hash: hash, nonce: nonce };
                            return newAnswer;
                        });
                        setCurrHash(0);
                    }} />
                </div>
            </div>
        </>
    )
}

// for 12 34
function Game2CalculationComponent2(props) {

    const navigate = useNavigate();

    function toHelp() {
        //navigate('/game2help')
        props.setShowHelpModal(true);
    }

    const { currHash, setUserAnswer, setCurrHash, userAnswer } = props;

    const [hash, setHash] = useState(0);
    const [nonce, setNonce] = useState(0);

    var pre1 = 0
    var pre2 = 0

    if (currHash === 12) {
        pre1 = 1;
        pre2 = 2;
    } else if (currHash === 34) {
        pre1 = 3;
        pre2 = 4;
    } else if (currHash === 1234) {
        pre1 = 12;
        pre2 = 34;
    }

    return (
        <>
            <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem' }}>
                <div className='row'>
                    <div className='col-4 btn_margin_help' style={{ paddingTop: '2%', paddingBottom: '2%', paddingLeft: '10%', paddingRight: '10%' }}>
                        <input type="button" onClick={e => toHelp()} className=' text-center btn_help ' value="HELP?" />
                    </div>
                    <div className="col-4"></div>
                    <div className=' text-center col-4'>
                        <p className='time_border'>
                            <Timer />
                        </p>
                    </div>
                </div>
                <div className='text-center'>
                    <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>Calculation of Hash {currHash} </p></b>
                </div>
                <div>
                    Detail of the Previous Hash Values<br /><br />
                    Hash {pre1}: {userAnswer[`b${pre1}`].hash}<br /><br />
                    Hash {pre2}: {userAnswer[`b${pre2}`].hash}<br /><br />
                </div>
                <br />
                <br />
                <div className='CalculationInput_div'>
                    <div>
                        Hash Value<br />
                        <input type="number" className='Calculation_hash_input' value={hash} onChange={e => setHash(e.target.value)}></input>
                    </div>
                    <br />
                    <div>
                        Nonce<br />
                        <input type="number" className='Calculation_hash_input' value={nonce} onChange={e => setNonce(e.target.value)}></input>
                    </div>
                </div>
                {/* <div className='d-flex justify-content-end' style={{ paddingTop: '1rem' }} >
                    <input type='button' className=' calculation_help fw-bold' value={"Help ?"} onClick={e => toHelp()} />
                </div> */}
            </div>
            <div style={{ paddingTop: '2rem' }}>
                <div className='Btns_Back'>
                    <input type="button" className='Btn_Back' value='Submit' onClick={() => {
                        if(!checkIsNumber(hash) || !checkIsNumber(nonce)) {
                            alert("Please enter a number");
                            return;
                        }
                        setUserAnswer(answer => {
                            let newAnswer = answer;
                            newAnswer[`b${currHash}`] = { hash: hash, nonce: nonce };
                            return newAnswer;
                        });
                        setCurrHash(0);
                    }} />
                </div>
            </div>
        </>
    )
}

// for 1234
function Game2CalculationComponent3(props) {

    const navigate = useNavigate();

    function toHelp() {
        // navigate('/game2help')
        props.setShowHelpModal(true);
    }

    const { socket, blockDetail, sessionID } = useContext(Context);

    const { setErrorTitle, setErrorMSG, setShowErrorModal, pvid, setPvid, currHash, setUserAnswer, setCurrHash, userAnswer } = props;

    const [hash, setHash] = useState(0);
    const [nonce, setNonce] = useState(0);

    var pre1 = 0
    var pre2 = 0

    if (currHash === 12) {
        pre1 = 1;
        pre2 = 2;
    } else if (currHash === 34) {
        pre1 = 3;
        pre2 = 4;
    } else if (currHash === 1234) {
        pre1 = 12;
        pre2 = 34;
    }

    const submitAnswer = async (answer) => {
        const result = await axios(`${EXPRESS_SERVER_URL}/game2/session/miners/blocks`, {
            method: 'POST',
            data: { bid: props.blockDetail.bid, pvid, answer: answer }
        })
        const json = await result.data
        if (json.status === 0) {
            // socket.emit("update_game2_votes", { sid: sessionID, bid: props.blockDetail.bid });
            // setCurrHash(-1);
            console.log(sessionID);
            const result = await axios(`${EXPRESS_SERVER_URL}/game2/session/blocks/votes`, {
                method: 'PUT',
                data: { bid: props.blockDetail.bid, sid: sessionID }
            })
            const json = await result.data
            if (json.status === 0) {
                socket.emit("update_game2_votes", { sid: sessionID, bid: props.blockDetail.bid });
                setCurrHash(-1);
            } else {
                console.log('vote' + json.err);
            }
        } else {
            setUserAnswer(answer => {
                let newAnswer = answer;
                delete newAnswer[`b${currHash}`];
                return newAnswer;
            });
            setErrorTitle('Error')
            setErrorMSG(json.err)
            setShowErrorModal(true)
        }
    }

    return (
        <>
            <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem' }}>
                <div className='row'>
                    <div className='col-4 btn_margin_help' style={{ paddingTop: '2%', paddingBottom: '2%', paddingLeft: '10%', paddingRight: '10%' }}>
                        <input type="button" onClick={e => toHelp()} className=' text-center btn_help ' value="HELP?" />
                    </div>
                    <div className="col-4"></div>
                    <div className=' text-center col-4'>
                        <p className='time_border'>
                            <Timer />
                        </p>
                    </div>
                </div>
                <div className='text-center'>
                    <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>Calculation of Hash {currHash} </p></b>
                </div>
                <div>
                    Detail of the Previous Hash Values<br /><br />
                    Hash {pre1}: {userAnswer[`b${pre1}`].hash}<br /><br />
                    Hash {pre2}: {userAnswer[`b${pre2}`].hash}<br /><br />
                </div>
                <br />
                <br />
                <div className='CalculationInput_div'>
                    <div>
                        Input Your Private ID For Confirmation<br />
                        <input type="number" className='Calculation_hash_input' value={pvid} onChange={e => setPvid(e.target.value)}></input>
                    </div>
                    <br />
                    <div>
                        Hash Value<br />
                        <input type="number" className='Calculation_hash_input' value={hash} onChange={e => setHash(e.target.value)}></input>
                    </div>
                    <br />
                    <div>
                        Nonce<br />
                        <input type="number" className='Calculation_hash_input' value={nonce} onChange={e => setNonce(e.target.value)}></input>
                    </div>
                </div>
                {/* <div className='d-flex justify-content-end' style={{ paddingTop: '1rem' }} >
                    <input type='button' className=' calculation_help fw-bold' value={"Help ?"} onClick={e => toHelp()} />
                </div> */}
            </div>
            <div style={{ paddingTop: '2rem' }}>
                <div className='Btns_Back'>
                    <input type="button" className='Btn_Back' value='Submit' onClick={() => {
                        if(!checkIsNumber(hash) || !checkIsNumber(nonce)) {
                            alert("Please enter a number");
                            return;
                        }
                        let ua = userAnswer;
                        ua[`b${currHash}`] = { hash: hash, nonce: nonce };
                        submitAnswer(ua);
                        setUserAnswer(ua);
                        // setCurrHash(-1);
                    }} />
                </div>
            </div>
        </>
    )
}

function HelpModal(props) {
    return (
        <Modal
            size="lg"
            show={props.showHelpModal}
            onHide={() => props.setShowHelpModal(false)}
            aria-labelledby="help-modal-sizes-title-lg"
            centered
            className="HelpModal_ModalStyle ">
            <Modal.Header className="HelpModal_Modalbc">
                <Modal.Title>Help</Modal.Title>
            </Modal.Header>

            <Modal.Body className="HelpModal_Modalbc">
                <div>
                    <div className='text-center'>
                        <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>Merkle Tree Rule</p></b>
                    </div>

                    <MerkleTree />

                    <div className='MerkleText'>
                        <div className='text-center'><b>The Rule of Merkle Tree:</b></div>

                        Hash 1 = DV(Data 1 + Previous Merkle Tree Root)*10 + Nonce<br />
                        Hash 2 = DV(Data 2 + Previous Merkle Tree Root)*10 + Nonce<br />
                        Hash 3 = DV(Data 3 + Previous Merkle Tree Root)*10 + Nonce<br />
                        Hash 4 = DV(Data 4 + Previous Merkle Tree Root)*10 + Nonce<br />
                        Hash 12 = DV(Hash 1 + Hash 2)*10 + Nonce<br />
                        Hash 34 = DV(Hash 3 + Hash 4)*10 + Nonce<br />
                        Hash 1234 = DV(Hash 12 + Hash 34)*10 + Nonce [*Merkle Tree Root]<br /><br />

                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="HelpModal_Modalbc">
                <Button variant="secondary" onClick={() => props.setShowHelpModal(false)} className="LoginPage_ModalCloasebtn">Close</Button>
            </Modal.Footer>
        </Modal>
    )
}


export default function Game2MerkleTree() {

    const navigate = useNavigate();

    const { socket, blockDetail, sessionID } = useContext(Context);

    const { bid, cid, pdid, pdq, pdn, dd, ph } = blockDetail;

    const [showMSG, setShowMSG] = useState(false)
    const [state, setState] = useState("tree");

    const [currHash, setCurrHash] = useState(0);
    const [userAnswer, setUserAnswer] = useState({});
    const [pvid, setPvid] = useState(0);

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);

    const [showHelpModal, setShowHelpModal] = useState(false);

    const [errorMSG, setErrorMSG] = useState('');
    const [errorTitle, setErrorTitle] = useState('');

    const [showRejectModal, setShowRejectModal] = useState(false);

    const checkIsMined = async () => {
        try {
            const result = await axios(`${EXPRESS_SERVER_URL}/game2/session/${sessionID}/miners/pbid/blocks/${bid}`, {
                method: 'GET'
            })
            const json = await result.data
            if (json.status === 0 && json.count) {
                navigate('/hashboardwaiting');
            }
        } catch (err) {
            console.log(err)
        }
    }

    const checkMinerCanMineThisBox = async () => {
        try {
            const check_result = await axios(`${EXPRESS_SERVER_URL}/game2/session/${sessionID}/blocks/${bid}/miners/check`, { method: 'GET' })
            const check_json = await check_result.data
            if (check_json.status === 0 && check_json.count === 0) {
                setShowRejectModal(true);
            } else if (check_json.status !== 0) {
                showErrorModelFunction(check_json.err)
            }
        } catch (err) {
            console.log(err)
            showErrorModelFunction('Error: ' + err.message)
        }
    }

    function showErrorModelFunction(msg) {
        setErrorMSG(msg);
        setShowErrorModal(true);
    }

    React.useEffect(() => {
        checkMinerCanMineThisBox();
        checkIsMined();
        const game2_block_end_listener = (message) => {
            console.log("game1_block_end");
            navigate('/hashboardwaiting');
        };
        const teacher_force_chained_game2_listener = (message) => {
            console.log("teacher_force_chained");
            navigate('/hashboardwaiting');
        };
        socket.on("game2_block_end", game2_block_end_listener);
        socket.on("game2_block_force_chained", teacher_force_chained_game2_listener);
        return () => {
            socket.off("game2_block_end", game2_block_end_listener);
            socket.off("game2_block_force_chained", teacher_force_chained_game2_listener);
        }
    }, [])

    // const getBlocks = async () => {
    //     try {

    //         const result = await axios(`${EXPRESS_SERVER_URL}/${gameVersion == 1 ? 'game1' : 'game2'}/session/sid/${sessionID}`, { method: 'GET' })
    //         const json = await result.data

    //         if (json.status === 0) {

    //         } else {
    //             console.log(json.err);
    //         }

    //     } catch (e) {
    //         console.log(e)
    //     }
    // }

    function setMSG() {
        setShowMSG(true)
    }

    React.useEffect(() => {
        let ua = Cookies.get(`s${sessionID}b${bid}`)
        if (ua) {
            setUserAnswer(JSON.parse(ua));
        }
    }, [])

    React.useEffect(() => {
        if (currHash < 0) {
            setState("submitted")
            setShowMSG(true)
        } else if (currHash === 0) {
            setState("tree")
        } else {
            setState("cal");
        }
    }, [currHash])

    const modalCallback = () => {
        navigate(-1);
    }

    React.useEffect(() => {
        if (userAnswer) {
            Cookies.set(`s${sessionID}b${bid}`, JSON.stringify(userAnswer), { expires: 1 })
        }
    }, [userAnswer.b1, userAnswer.b2, userAnswer.b3, userAnswer.b4, userAnswer.b12, userAnswer.b34, userAnswer.b1234])

    if (state === "tree") {
        return (
            <div>
                <TitleBar backLastPage="" lastPageName="" />
                <div className='text-center'>
                    <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}> Merkle Tree</p></b>
                </div>
                <MerkleTree clickable={true} setCurrHash={setCurrHash} userAnswer={userAnswer} />
                <br />
                <br />
                <br /><br />
                <br /><br />
                {/* <div className='Btns_Back'>
                    <input type="button" className='Btn_Back' value='Submit' onClick={e => setMSG()} />
                </div> */}
                <div className='Btns_Back'>
                    <input type="button" className='Btn_Back' value='Back' onClick={e => { navigate(-1); setShowConfirmModal(true) }} />
                </div>
                {/* <ConfirmModal
                    title="Are you sure?"
                    msg="The system will not save your input!"
                    show={showConfirmModal}
                    setShow={setShowConfirmModal}
                    confirm={() => {
                        navigate(-1)
                    }}
                /> */}
                <ErrorModal showErrorModal={showRejectModal} setShowErrorModal={modalCallback} errorTitleMSG='Hi newcomer' errorMSG="Please wait for the next block" />
                <ErrorModal showErrorModal={showErrorModal} setShowErrorModal={setShowErrorModal} errorTitleMSG={errorTitle} errorMSG={errorMSG} />
            </div>
        )
    } else if (state === "cal") {
        if (currHash <= 4) {
            return (
                <>
                    <TitleBar backLastPage="" lastPageName="" />
                    <Game2CalculationComponent setShowHelpModal={setShowHelpModal} setErrorTitle={setErrorTitle} setErrorMSG={setErrorMSG} setShowErrorModal={setShowErrorModal} blockDetail={blockDetail} currHash={currHash} setUserAnswer={setUserAnswer} setCurrHash={setCurrHash} />
                    <div className='Btns_Back'>
                        <input type="button" className='Btn_Back' value='Back' onClick={e => setCurrHash(0)} />
                    </div>
                    <ErrorModal showErrorModal={showErrorModal} setShowErrorModal={setShowErrorModal} errorTitleMSG={errorTitle} errorMSG={errorMSG} />
                    <HelpModal showHelpModal={showHelpModal} setShowHelpModal={setShowHelpModal} />
                </>
            )
        } else if (currHash <= 34) {
            return (
                <>
                    <TitleBar backLastPage="" lastPageName="" />
                    <Game2CalculationComponent2 setShowHelpModal={setShowHelpModal} setErrorTitle={setErrorTitle} setErrorMSG={setErrorMSG} setShowErrorModal={setShowErrorModal} blockDetail={blockDetail} userAnswer={userAnswer} currHash={currHash} setUserAnswer={setUserAnswer} setCurrHash={setCurrHash} />
                    <div className='Btns_Back'>
                        <input type="button" className='Btn_Back' value='Back' onClick={e => setCurrHash(0)} />
                    </div>
                    <ErrorModal showErrorModal={showErrorModal} setShowErrorModal={setShowErrorModal} errorTitleMSG={errorTitle} errorMSG={errorMSG} />
                    <HelpModal showHelpModal={showHelpModal} setShowHelpModal={setShowHelpModal} />
                </>
            )
        } else {
            return (
                <>
                    <TitleBar backLastPage="" lastPageName="" />
                    <Game2CalculationComponent3 setShowHelpModal={setShowHelpModal} setErrorTitle={setErrorTitle} setErrorMSG={setErrorMSG} setShowErrorModal={setShowErrorModal} blockDetail={blockDetail} pvid={pvid} setPvid={setPvid} userAnswer={userAnswer} currHash={currHash} setUserAnswer={setUserAnswer} setCurrHash={setCurrHash} />
                    <div className='Btns_Back'>
                        <input type="button" className='Btn_Back' value='Back' onClick={e => setCurrHash(0)} />
                    </div>
                    <ErrorModal showErrorModal={showErrorModal} setShowErrorModal={setShowErrorModal} errorTitleMSG={errorTitle} errorMSG={errorMSG} />
                    <HelpModal showHelpModal={showHelpModal} setShowHelpModal={setShowHelpModal} />
                </>
            )
        }
    } else {
        return (
            <div>
                <TitleBar backLastPage="" lastPageName="" />
                <div className='text-center'>
                    <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}> Merkle Tree</p></b>
                </div>
                <PopUpModal setShowMSG={setShowMSG} showMSG={showMSG} MSGContext={<>Your Hash and Nonce has submitted! <br /> Please continue to hash other part in the Merkle Tree</>} MSGTitle={""} MSGBtn={"Continue"} Link={"hashboardwaiting"} />
            </div>
        )
    }
}